import React from 'react';
import { Row, Tooltip } from "antd";

export const ParameterECButton = ({ handleClick, tankEC, tankTemp, trueCrashes, ecTitle, tempTitle }) => {
    let ecValue = tankEC || tankEC == 0
        ? (Math.round((tankEC) * 100) / 100).toFixed(1)
        : "-";
    let tempValue = tankTemp || tankTemp == 0
        ? (Math.round((tankTemp) * 100) / 100).toFixed(1)
        : "-";

    const rowStyle = {
        alignItems: 'flex-end',
        padding: '14px 0px',
        justifyContent: 'center',
        height: 72.5
    };
    const spanStyle = {
        fontSize: 32,
        marginRight: 13,
        width: 45,
    };
    const pStyle = {
        fontSize: 47,
        fontWeight: 'bold',
        margin: 0,
        color: trueCrashes.length > 0 ? '#FF0000' : '#00FA9E',
        lineHeight: '42px',
        minWidth: 143,
    };

    return <div
        onClick={handleClick}
    >
        <Row
            className="record-box"
            style={rowStyle}>
            <span
                style={spanStyle}>
                EC
            </span>
            <Tooltip
                placement="topLeft"
                title={
                    trueCrashes.length > 0
                        ? trueCrashes.map(crash => crash.meta?.title || '').join('; ')
                        : ecValue !== '-' ? ecValue + ' - ' + ecTitle?.title : ecTitle?.noneEcTitle
                }
            >
                <p
                    className="wrap-text"
                    style={pStyle}
                >
                    {
                        ecValue
                    }
                </p>
            </Tooltip>
        </Row>
        <Row
            className="record-box"
            style={rowStyle}>
            <span
                style={spanStyle}>
                t°
            </span>
            <Tooltip
                placement="topLeft"
            title={
                trueCrashes.length > 0
                    ? trueCrashes.map(crash => crash.meta?.title || '').join('; ')
                    : tempValue !== '-' ? tempValue + ' - ' + tempTitle?.title : tempTitle?.noneTempTitle
            }
            >
                <p
                    className="wrap-text"
                    style={pStyle}
                >
                    {
                        tempValue
                    }
                </p>
            </Tooltip>
        </Row>
    </div>
}